import React from 'react'
import { usePopup } from '@deseretbook/react-utils'

/**
 * This is a wrapper for class based components to use the usePopup hook
 * @param {func} Component - React component
 * @returns {func} React Component
 */
export const withPopupProps = Component => props => {
  const popup = usePopup()

  return (
    <React.Fragment>
      <Component {...props} popup={popup} />
    </React.Fragment>
  )
}
